import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import LinkBank from "./linkBank";
import LoadingPopup from "./loading";
import Avatar from "react-avatar";
import selectBankClicked from "../../assests/page/select-bank-clicked.svg";
import debitCard from "../../assests/page/debit-card.svg";
import accountIcon from "../../assests/page/account-balance-icon.svg";
import {
  moneyHubContinents,
  stripeSupportedCountriesCode,
} from "../../utils/constants";

export const LinkBankOption = (props) => {
  const { allCountries } = props.generalDataProps;

  return (
    <div className="add-funds-popup">
      <div className="add-funds-content">
        <div className="add-funds-content-header">
          <div className="add-funds-content-header-text-container">
            <img
              onClick={() => {
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(
                  <LinkBank
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    buttonAction="link bank"
                    generalDataProps={props.generalDataProps}
                  />,
                );
              }}
              className="add-funds-popup-back-icon"
              alt="Back Icon"
              src={backIcon}
            />
            <p className="add-funds-content-header-text">Link Bank Options</p>
          </div>
          <img
            onClick={() => {
              props.setShowPopup(false);
              props.setPopupContent(null);
              if (props.setPopupContentPosition) {
                props.setPopupContentPosition("center");
              }
              if (props.setFavouriteClicked) {
                props.setFavouriteClicked(false);
              }
            }}
            className="add-funds-popup-close-icon"
            alt="Close Icon"
            src={popupCloseIcon}
          />
        </div>
        <div className="payments-popup-content-footer">
          <div className="payments-popup-content-footer-container">
            <div
              onClick={() => {
                props.setPopupContent(
                  <LinkBank
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    buttonAction={"link-bank"}
                    generalDataProps={props.generalDataProps}
                    countryList={
                      allCountries
                        ? Object.values(allCountries)?.filter(
                            (cnt) =>
                              moneyHubContinents.includes(
                                cnt?.continent?.toLowerCase(),
                              ) || cnt?.code === "BR",
                          )
                        : []
                    }
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              }}
              className="payments-popup-content-footer-main"
            >
              <div className="payments-popup-content">
                <div className="payments-popup-content-icon">
                  <img src={accountIcon} alt="Payment Method Icon" />
                </div>
                <p className="payments-popup-content-text">Connect To Bank</p>
              </div>
            </div>

            <div
              onClick={() => {
                props.setPopupContent(
                  <LinkBank
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    buttonAction={"link-card"}
                    generalDataProps={props.generalDataProps}
                    countryList={
                      allCountries
                        ? Object.values(allCountries)?.filter((cnt) =>
                            stripeSupportedCountriesCode.includes(
                              cnt?.countryCode?.toUpperCase(),
                            ),
                          )
                        : []
                    }
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              }}
              className="payments-popup-content-footer-main"
            >
              <div className="payments-popup-content">
                <div className="payments-popup-content-icon">
                  <img src={debitCard} alt="Payment Method Icon" />
                </div>
                <p className="payments-popup-content-text">Connect To Card</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LinkBankList = (props) => {
  return (
    <div className="add-funds-popup">
      <div
        style={{ overflowX: "hidden", overflowY: "auto" }}
        className="add-funds-content"
      >
        <div className="add-funds-content-header">
          <div className="add-funds-content-header-text-container">
            <img
              className="profile-popup-icon"
              onClick={() => {
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(props.backClickPopup);
              }}
              alt="Close Icon"
              src={backIcon}
            />
            <p className="add-funds-content-header-text">Select Bank Account</p>
          </div>
          <img
            onClick={() => {
              props.setShowPopup(false);
              props.setPopupContent(null);
              props.setPopupContentPosition("center");
              if (props.setFavouriteClicked) {
                props.setFavouriteClicked(false);
              }
            }}
            className="add-funds-popup-close-icon"
            alt="Close Icon"
            src={popupCloseIcon}
          />
        </div>

        <div className="select-bank-popup">
          <div className="select-bank-popup-container">
            <div className="select-bank-popup-body">
              <div className="select-bank-popup-body-container">
                {props.bankList.map((bnk) => (
                  <div className="select-bank-popup-body-content">
                    <div className="select-bank-popup-body-content-container">
                      <div className="select-bank-popup-body-content-icon">
                        {bnk?.icon && <img src={bnk.icon} alt="Bank Logo" />}
                        {!bnk?.icon && <Avatar name={bnk.productName} />}
                      </div>

                      <div className="select-bank-popup-body-content-main">
                        <div className="select-bank-popup-body-content-text-container">
                          <p className="select-bank-popup-body-content-text">
                            {bnk.productName}
                          </p>
                          <p className="select-bank-popup-body-content-label">
                            {bnk.accountName}
                          </p>
                        </div>
                        <img src={selectBankClicked} alt="Checkbox Icon" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="stripe-popup-buttons">
        <button
          onClick={() => {
            props.setPopupContent(
              <LinkBank
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                currentStep="2"
                generalDataProps={props.generalDataProps}
              />,
            );
            props.setPopupContentPosition("flex-end");
            props.setShowPopup(true);
          }}
          className="verify-kyc-button-back"
        >
          <p className="verify-kyc-button-back-text">Connect new Bank(s)</p>
        </button>
        <button
          onClick={() => {
            props.setPopupContent(
              <LoadingPopup
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                action="stripe-connect"
                isCustom={true}
                customTextHeader="Searching..."
                customTextFooter={`Looking for card linked with your wallet in ${props.countryCode}`}
                countryCode={props.countryCode}
                generalDataProps={props.generalDataProps}
              />,
            );
            props.setPopupContentPosition("flex-end");
            props.setShowPopup(true);
          }}
          className="verify-kyc-button"
        >
          <p className="verify-kyc-button-text">Link Banks</p>
        </button>
      </div>
    </div>
  );
};
